// src/components/search/SearchResultsList.tsx
"use client";

import { useRouter } from "next/navigation";
import { useAppSelector } from "../../../redux/hooks";
import { selectSearchResults } from "../../../redux/selectors/main/mainSelectors";
import type { OfficialVideo } from "../../../types/main/mainTypes";
import "./SearchResultsList.css";

type Props = { query: string };

const OFFICIAL_DETAIL_ENDPOINT = "/official-videos"; // consumed by /app/video/[slug]

const SearchResultsList = ({ query }: Props) => {
  const router = useRouter();
  const results = useAppSelector(selectSearchResults);

  // guard: too short
  const q = (query || "").trim();
  if (q.length < 2) return null;

  // simple client-side filter (title contains query)
  const filtered = (results as OfficialVideo[])
    .filter((v) => (v.title || "").toLowerCase().includes(q.toLowerCase()))
    .slice(0, 5);

  if (filtered.length === 0) {
    return <div className="search-result-empty">No matching videos found.</div>;
  }

  // build unified watch URL: /video/[slug]?e=/official-videos&...
  const toWatchHref = (v: OfficialVideo) =>
    `/video/${encodeURIComponent(v.slug)}?` +
    new URLSearchParams({
      e: OFFICIAL_DETAIL_ENDPOINT, // detail endpoint for UniversalVideoPageClient
      s: "flat",                   // flat mode
      a: "auto",                   // aspect auto
      p: "0",                      // no forced poster
      t: v.title || "",            // optional title
    }).toString();

  return (
    <ul className="search-result-list">
      {filtered.map((video) => (
        <li
          key={video.id}
          className="search-result-item"
          onClick={() => router.push(toWatchHref(video))}
          role="button"
          tabIndex={0}
        >
          <span className="search-result-title">{video.title}</span>
        </li>
      ))}
    </ul>
  );
};

export default SearchResultsList;
